import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { McpInstallCard } from '../components/mcp-install-card.js';

const parentRoute = getRouteApi('/brand/$slug/settings');

// Spec §13.8 — the MCP is a SIDE DOOR, "surfaced in Settings, not in the main
// onboarding flow". This is that surface.
//
// WHY ITS OWN PANE rather than a card appended to communication. The rail's
// panes each answer one question, and this file's siblings exist because one
// pane answering two (WHERE mag reaches you and WHAT about) grew to 883 lines
// before it was split. Communication is about how mag reaches the founder;
// this is the opposite direction — how the founder reaches mag from somewhere
// else — so folding it in would reintroduce exactly the conflation that split
// fixed.
//
// NOT in the onboarding checklist, which is the other placement that was
// considered. onboarding-checklist.tsx computes `allSettled` across its steps
// and that value drives confetti and the whole checklist unmounting, for every
// founder including ones already onboarded. Adding a step there changes
// completion state for people who finished months ago, so it is a deliberate
// change with its own blast radius rather than a mount — and §13.8 asks for
// Settings regardless.
export const Route = createFileRoute('/brand/$slug/settings/ai-tool')({
  component: AiToolPage,
});

function AiToolPage() {
  const { brand } = parentRoute.useLoaderData();
  return <McpInstallCard brandName={brand.name} />;
}
